import React from 'react';

import { TableContainer, Table, Thead, Tbody, Tr } from '@chakra-ui/react';

import { StyledTd } from './StyledTableCell';

type CompositionGroupTableProps = {
  headerRows: React.ReactNode;
  bodyRows: React.ReactNode;
  isEmpty?: boolean;
  emptyStateLabel?: string;
  emptyStateColSpan?: number;
};

const CompositionGroupTable: React.FC<CompositionGroupTableProps> = ({
  headerRows,
  bodyRows,
  isEmpty = false,
  emptyStateLabel = 'Sem dados',
  emptyStateColSpan = 1,
}) => {
  return (
    <TableContainer width="100%" overflowX="visible">
      <Table
        size="sm"
        width="100%"
        sx={{
          th: {
            textColor: 'gray.700',
          },
          'th, td': {
            borderColor: 'gray.300',
            borderWidth: '1px',
          },
          'tbody tr:nth-of-type(odd) td': {
            backgroundColor: 'gray.50',
            borderColor: 'gray.300',
            borderWidth: '1px',
          },
        }}
      >
        <Thead>{headerRows}</Thead>
        <Tbody>
          {isEmpty ? (
            <Tr>
              <StyledTd
                colSpan={emptyStateColSpan}
                textAlign="center"
                fontStyle="italic"
              >
                {emptyStateLabel}
              </StyledTd>
            </Tr>
          ) : (
            bodyRows
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default CompositionGroupTable;
